import { hasAccess } from '@/shared/services/hasAccess';

/**
 * Landing candidates in nav order, each with the menu role that opens it.
 *
 * Mirrors the top of NavigationMenu deliberately: the page someone lands on
 * should be the first one they can actually see in the sidebar.
 */
const LANDING_ROUTES: Array<{ path: string; roles: string[] }> = [
  { path: '/games', roles: ['menu:games'] },
  { path: '/clips', roles: ['menu:clips'] },
];

/**
 * Where a user with no menu role at all goes. Account Settings is the one page
 * with no requiredPermissions, so it always renders — which matters, because
 * AccessDenied's "Back to Application" button returns to '/'. Landing on a
 * gated page would bounce the user between the two forever.
 */
const FALLBACK_ROUTE = '/account-settings';

/**
 * The first page these roles can open.
 *
 * '/' used to redirect unconditionally to /games, which is fine for every
 * group that holds menu:games and a dead end for one that does not — Clip
 * Operator, for instance, whose only page is Clip Management.
 */
export const getLandingRoute = (roles: string[] | null | undefined): string =>
  LANDING_ROUTES.find(route => hasAccess(roles, route.roles))?.path ?? FALLBACK_ROUTE;
